import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import NavigationLink from "../../components/NavigationLink/NavigationLink";
import LiftBindings from "../LiftBindings/LiftBindings";
import { EditActions, editActions } from "../../actions/editActions";
import { PdApiActions, pdApiActions } from "../../actions/pdApiActions";
import { ColumnActions, columnActions } from "../../actions/columnActions";
import {
  editedObjectIdSelector,
  isEditActiveSelector,
  editedObjectIdentifierSelector,
  domainSelector
} from "../../reducers/editReducer";
import { LiftParametersTable } from "./Parameters/LiftParametersTable";
import { LiftFaultsTable } from "./Faults/LiftFaultsTable";
import { ParameterCategoriesTable } from "../common/ParameterCategories/ParameterCategoriesTable";
import { FaultComponentsTableCommon } from "./FaultComponents/FaultComponentsTableCommon";
import { GrandNormsTable } from "../common/GrandNorms/GrandNormsTable";
import {
  setFaultExtraProperties,
  setParameterExtraProperties,
  createEmptyParameter,
  createEmptyFault,
  createEmptyParameterCategory,
  setParameterCategoryEnumExtraProperties,
  createEmptyDataActCode,
  createEmptyFaultComponent,
  setFaultComponentExtraProperties,
  createEmptyGrandNorm,
  setGrandNormExtraProperties
} from "../../utils/pdApiUtils";
import { ActionMenu } from "../common/ActionMenu/ActionMenu";
import ContentLayout from "../../components/ContentLayout/ContentLayout";
import { EventEnumerations } from "./EventEnumerations/EventEnumerations";
import { IOEnumerations } from "./IOEnumerations/IOEnumerations";
import DataAct from "../Lift/DataAct/DataAct";
import { mainActions } from "../../actions/mainActions";
import { Filter } from "../../components/Table/Migration/LegacyTypes";

type StateProps = {
  pdApi: State.PdApi;
  fetchingStatus: string | undefined;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  editedObject: Api.AnyItem | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
  domainName: string;
  toggleChildView: State.ToggleChildView;
  isLoadingParameters: boolean;
  isLoadingFaults: boolean;
  isGrandNormsLoading: boolean;
  filterOptions: State.FilterOptions;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
  columnActions: typeof columnActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  subMenuRoute: State.LiftSubmenu;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  match: any;
  userFiltering?: Filter[];
};

// Props of the component
export type LiftProps = StateProps & DispatchProps & OwnProps;

type LiftState = {
  isModalOpen: boolean;
  tableColumnFilters: {
    [key in State.LiftSubmenu]: Filter[];
  };
};

export class Lift extends React.Component<LiftProps, LiftState> {
  state = {
    isModalOpen: false,
    tableColumnFilters: {
      "Elevator Faults": [],
      "Elevator Parameters": [],
      "Elevator Bindings": [],
      "Fault Components": [],
      "Parameter Categories": [],
      "Event Enumerations": [],
      "IO Enumerations": [],
      "Data Act": [],
      "Grand Norm": []
    }
  };

  private groupName: Api.GroupName = "Lift";
  /**
   * To add new sub page to this parent, add it here
   */
  subPages: Internal.SubPages = {
    "Elevator Parameters": {
      itemName: "parameter",
      PdApiField: "liftParameters",
      dataView: LiftParametersTable,
      createEmpty: createEmptyParameter,
      setExtraProperties: setParameterExtraProperties
    },

    "Elevator Faults": {
      itemName: "fault",
      PdApiField: "liftFaults",
      dataView: LiftFaultsTable,
      createEmpty: createEmptyFault,
      setExtraProperties: setFaultExtraProperties
    },
    "Elevator Bindings": {
      itemName: "binding",
      createEmpty: () => {
        /*  */
      },
      PdApiField: null,
      dataView: LiftBindings,
      setExtraProperties: null
    },

    "Fault Components": {
      itemName: "fault component",
      PdApiField: "faultComponents",
      dataView: FaultComponentsTableCommon,
      createEmpty: createEmptyFaultComponent,
      setExtraProperties: setFaultComponentExtraProperties
    },
    "Parameter Categories": {
      itemName: "parameter category",
      PdApiField: "parameterCategories",
      dataView: ParameterCategoriesTable,
      createEmpty: createEmptyParameterCategory,
      setExtraProperties: setParameterCategoryEnumExtraProperties
    },
    "Event Enumerations": {
      itemName: "event enumeration",
      PdApiField: null,
      dataView: EventEnumerations,
      createEmpty: () => {
        /*  */
      },
      setExtraProperties: null
    },
    "IO Enumerations": {
      itemName: "io enumeration",
      PdApiField: null,
      dataView: IOEnumerations,
      createEmpty: () => {
        /*  */
      },
      setExtraProperties: null
    },
    "Data Act": {
      itemName: "data act",
      PdApiField: "dataActCodes",
      dataView: DataAct,
      createEmpty: createEmptyDataActCode,
      setExtraProperties: null
    },
    "Grand Norm": {
      itemName: "grand norm",
      PdApiField: "grandNorms",
      dataView: GrandNormsTable,
      createEmpty: createEmptyGrandNorm,
      setExtraProperties: setGrandNormExtraProperties
    }
  };
  componentDidMount(): void {
    if (
      this.props.pdApi.driveFaults === undefined &&
      window.location.href.includes("elevator/faults")
    ) {
      this.props.pdApiActions.fetchLiftFaults();
      this.props.pdApiActions.fetchAPMFaults();
    }
    if (this.props.pdApi.grandNorms === undefined) {
      this.props.pdApiActions.fetchGrandNorms();
    }
  }
  render(): JSX.Element {
    const { subMenuRoute } = this.props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const submenuLinks = Object.keys(this.subPages).map((subPageName: any) =>
      this.buildLink(subPageName)
    );
    const actionMenu = this.getActionMenu(subMenuRoute);
    const dataView = this.getDataView(subMenuRoute);
    const modal = this.subPages[subMenuRoute].PdApiField ? this.buildModal() : null;
    return (
      <>
        <ContentLayout submenu={submenuLinks} actionMenu={actionMenu} dataView={dataView} />
        {modal}
      </>
    );
  }

  private setColumnFilters = (subMenuRoute: State.LiftSubmenu, newFilters: Filter[]): void => {
    const newFilterSet = { ...this.state.tableColumnFilters, [subMenuRoute]: newFilters };
    this.setState(prevState => ({
      ...prevState,
      tableColumnFilters: newFilterSet
    }));
  };

  private getDataView = (subMenuRoute: State.LiftSubmenu): JSX.Element => {
    if (subMenuRoute === "Parameter Categories") {
      const passProps = {
        ...this.props,
        toggleModal: this.toggleModal,
        setColumnFilters: this.setColumnFilters,
        groupName: "Lift"
      };
      return React.createElement(this.subPages[subMenuRoute].dataView, passProps);
    } else if (subMenuRoute === "Fault Components") {
      const passProps = {
        ...this.props,
        toggleModal: this.toggleModal,
        setColumnFilters: this.setColumnFilters,
        parentMenu: "Lift" as const,
        groupName: "Lift"
      };
      return React.createElement(this.subPages[subMenuRoute].dataView, passProps);
    } else if (subMenuRoute === "Grand Norm") {
      const passProps = {
        ...this.props,
        toggleModal: this.toggleModal,
        setColumnFilters: this.setColumnFilters,
        groupName: "Lift"
      };
      return React.createElement(this.subPages[subMenuRoute].dataView, passProps);
    } else if (subMenuRoute in this.subPages) {
      const passProps = {
        ...this.props,
        toggleModal: this.toggleModal,
        setColumnFilters: this.setColumnFilters
      };
      return React.createElement(this.subPages[subMenuRoute].dataView, passProps);
    }
    return <>Error</>;
  };

  private getActionMenu = (subMenuRoute: State.LiftSubmenu): JSX.Element | null => {
    if (
      subMenuRoute === "Elevator Bindings" ||
      subMenuRoute === "Event Enumerations" ||
      subMenuRoute === "IO Enumerations" ||
      this.subPages[subMenuRoute].PdApiField === null
    ) {
      return null;
    }
    return (
      <ActionMenu
        {...this.props}
        itemName={this.subPages[subMenuRoute].itemName}
        groupName={this.groupName}
        selectedColumnsName={subMenuRoute}
        dataFieldName={this.subPages[subMenuRoute].PdApiField}
        setExtraProperties={this.subPages[subMenuRoute].setExtraProperties}
        createEmpty={this.subPages[subMenuRoute].createEmpty}
        columnFilters={this.state.tableColumnFilters[subMenuRoute]}
      />
    );
  };

  private buildLink = (subPageName: State.LiftSubmenu): JSX.Element => {
    // To dynamically build urls we use the itenName and make it plural, so -s || -y => -ies
    let parsedLink = this.subPages[subPageName].itemName.replace(" ", "-");
    parsedLink = parsedLink.slice(-1) === "y" ? parsedLink.slice(0, -1) + "ies" : parsedLink + "s";
    return (
      <NavigationLink
        key={subPageName}
        handleOnClick={() => this.handleLinkClick(subPageName)}
        name={subPageName}
        to={"/elevator/" + parsedLink + "/"}
      />
    );
  };

  private handleLinkClick = (subPageName: Api.AnyItem) => {
    this.props.editActions.cancelEditing;
    if (subPageName === "Elevator Faults" && this.props.pdApi.liftFaults === undefined) {
      this.props.pdApiActions.fetchLiftFaults();
    }
  };

  private buildModal = () => {
    const domainName = this.props.domainName ? " Domain: " + this.props.domainName : "";
    const content = (
      <span>
        Are you sure you want to delete this {this.subPages[this.props.subMenuRoute].itemName}?
        <br />
        {this.props.objectIdentifier}
        <br /> {domainName}
      </span>
    );

    return (
      <ConfirmationModal
        isOpen={this.state.isModalOpen}
        size="mini"
        header="Confirm delete"
        content={content}
        confirmText="Confirm"
        cancelText="Cancel"
        onConfirm={() => {
          if (this.subPages[this.props.subMenuRoute].itemName === "data act") {
            this.props.editActions.delete("dataActs");
          } else {
            this.props.editActions.delete(
              this.subPages[this.props.subMenuRoute].PdApiField as Api.OptionsGrud
            );
          }
        }}
        onCancel={this.toggleModal}
      />
    );
  };

  /*
   * Toggles the modal based on previous state.
   */
  private toggleModal = (): void => {
    this.setState(prevState => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen
    }));
  };
}

const mapStateToProps = (state: State.Root, ownProps: OwnProps) => ({
  fetchingStatus: state.main.fetchingStatus,
  columns: state.columns,
  pdApi: state.pdApi,
  isLoadingFaults: state.loadingStatus.isLiftFaultsLoading,
  isLoadingParameters: state.loadingStatus.isLoadingParameters,
  isGrandNormsLoading: state.loadingStatus.isGrandNormsLoading,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView),
  editedObjectId: editedObjectIdSelector(state.editView),
  editedObject: state.editView.editedObject,
  objectIdentifier: editedObjectIdentifierSelector(state.editView, ownProps.subMenuRoute),
  domainName: domainSelector(state.editView),
  toggleChildView: state.toggleChildView,
  filterOptions: state.filterOptions
});

const mapDispatchToProps = (dispatch: Dispatch<PdApiActions | ColumnActions | EditActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch),
  columnActions: bindActionCreators({ ...columnActions }, dispatch),
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Lift);
